export function Lighting() {
  return (
    <>
      <ambientLight intensity={0.08} color="#1a1822" />

      {/* Warm cinematic key light */}
      <directionalLight
        position={[6, 8, 4]}
        intensity={1.4}
        color="#f6d28a"
        castShadow
        shadow-mapSize-width={1024}
        shadow-mapSize-height={1024}
      />

      {/* Cool rim from behind */}
      <directionalLight position={[-6, 2, -8]} intensity={0.5} color="#6e8cff" />

      {/* Soft fill from above */}
      <pointLight position={[0, 6, 2]} intensity={0.6} color="#ffffff" distance={20} decay={2} />

      {/* Underglow near the gold/oil zones */}
      <pointLight position={[0, -2, -14]} intensity={1.2} color="#c9a24a" distance={12} decay={2} />
      <pointLight position={[0, 0, -28]} intensity={1.4} color="#5b8cff" distance={14} decay={2} />
      <pointLight position={[0, 0, -42]} intensity={0.9} color="#9d7bff" distance={16} decay={2} />
    </>
  );
}
